import xlsx from "json-as-xlsx";

export const getHTTPOnlyCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
};

export const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = reject;
  });
};

export const debounce = (fn, time) => {
  let timeoutId;
  return wrapper;
  function wrapper(...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      timeoutId = null;
      fn(...args);
    }, time);
  }
};

export const numberToWords = (n) => {
  if (n < 0) return false;
  let single_digit = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  let double_digit = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  let below_hundred = [
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];
  if (n === 0) return "Zero";
  function translate(n) {
    let word = "",
      rem;
    if (n < 10) {
      word = single_digit[n] + " ";
    } else if (n < 20) {
      word = double_digit[n - 10] + " ";
    } else if (n < 100) {
      rem = translate(n % 10);
      word = below_hundred[(n - (n % 10)) / 10 - 2] + " " + rem;
    } else if (n < 1000) {
      word =
        single_digit[Math.trunc(n / 100)] + " Hundred " + translate(n % 100);
    } else if (n < 1000000) {
      word =
        translate(parseInt(n / 1000)).trim() +
        " Thousand " +
        translate(n % 1000);
    } else if (n < 1000000000) {
      word =
        translate(parseInt(n / 1000000)).trim() +
        " Million " +
        translate(n % 1000000);
    } else {
      word =
        translate(parseInt(n / 1000000000)).trim() +
        " Billion " +
        translate(n % 1000000000);
    }
    return word;
  }
  let result = translate(n);
  return result.trim();
};

export const downloadReports = (data, settings) => {
  xlsx(data, settings); // Will download the excel file
};

export const downloadReportsFun = (
  data,
  fileName,
  type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
) => {
  const blob = new Blob([data], { type: type });
  const downloadLink = document.createElement("a");
  downloadLink.href = window.URL.createObjectURL(blob);
  downloadLink.download = fileName;
  downloadLink.click();
};

// Function to set a cookie
export function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

// export Function to get a cookie
export function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

// export Function to delete a cookie
export function deleteCookie(name) {
  document.cookie = name + "=; Max-Age=-99999999;";
}

export const approvedAmountPassAccordingToLevel = value => {
  const {finance_amount_approved = "", l2_amount_approved = "", l1_amount_approved = "", amount = ""} = value
  return finance_amount_approved || l2_amount_approved || l1_amount_approved || amount || ""
}

export const switchLabel = (key) => {
    switch (key) {
      case "Finance":
        return "l2_amount_approved"
      case "L2":
        return "l1_amount_approved"
      case "L1":
        return "amount"
      case "Store":
        return "amount"
    
      default:
        return "amount"
    }
}

export const labelSplitFun = (key) => {

// L1ApprovalPending,
// L1Rejected,
// L2ApprovalPending,
// L2Rejected,
// AccountsApprovalPending,
// AccountsRejected,
// Approved

    switch (key) {
      case "L1ApprovalPending":
        return "L1 Approval Pending"
      case "L1Rejected":
        return "L1 Rejected"
      case "L2ApprovalPending":
        return "L2 Approval Pending"
      case "L2Rejected":
        return "L2 Rejected"
      case "AccountsApprovalPending":
        return "Accounts Approval Pending"
      case "AccountsRejected":
        return "Accounts Rejected"
      case "Approved":
        return "Approved"
      default:
        return "Approved"
    }
}

export const displayDateFormat = "DD MMM yyy HH:mm";
export const sendToDBDateFormat = "YYYY-MM-DD HH:mm:ss";


/** Returns an array of store codes for API payloads. Never returns [null] or undefined entries.
 * Backend resolves stores from username when storeCodes is empty. */
export const getArrayOfSelectedStoresCode = (selectedStoreOption, storeDropdownState) => {
  const selectedCode =
    selectedStoreOption?.storeDetails?.storeCode ||
    selectedStoreOption?.storeCode ||
    selectedStoreOption?.value;
  if (selectedCode && selectedCode !== "All") {
    return [selectedCode].filter((c) => c != null && c !== "");
  }

  // When store selection is missing/All, send all dropdown stores.
  // If dropdown is unavailable, return [] so backend resolves mapped stores by user.
  const dropdownItems = Array.isArray(storeDropdownState)
    ? storeDropdownState
    : storeDropdownState
    ? [storeDropdownState]
    : [];

  return dropdownItems
    .map((item) => item?.storeCode || item?.storeDetails?.storeCode || item?.value)
    .filter((code) => code != null && code !== "" && code !== "All");
}

// Helper function to check if a status contains "REWORK" (case-insensitive pattern matching)
// Matches backend LIKE '%REWORK%' pattern to capture all rework-related statuses
// Exported for use in status display logic
export const containsRework = (status) => {
  if (!status || typeof status !== "string") return false;
  return status.toUpperCase().includes("REWORK");
};

// Status is "rework complete" (approved after rework) - voucher is NOT in rework
const isReworkCompleteStatus = (s) => {
  if (!s || typeof s !== "string") return false;
  const u = s.toUpperCase().trim();
  return u === "REWORK APPROVED" || u === "REWORKAPPROVED" || u === "ACCOUNTSREWORKAPPROVED";
};

// Check if voucher is in rework
export const isVoucherInRework = (voucherData) => {
  if (!voucherData) return false;

  const l1Status = voucherData?.newL1Status || voucherData?.l1Status || voucherData?.L1?.status || "";
  const l2Status = voucherData?.newL2Status || voucherData?.l2Status || voucherData?.L2?.status || "";
  const l3Status = voucherData?.newL3Status || voucherData?.l3Status || voucherData?.L3?.status || "";
  const financeStatus = voucherData?.Finance?.status || voucherData?.financeStatus || "";

  // CRITICAL: If any level shows "Rework Approved", rework is COMPLETE - hide edit button for Store
  if (isReworkCompleteStatus(l1Status) || isReworkCompleteStatus(l2Status) || isReworkCompleteStatus(l3Status) || isReworkCompleteStatus(financeStatus)) {
    return false;
  }

  // If voucher has been resubmitted, it's NO LONGER in rework
  if (voucherData?.workflowStepResponses && Array.isArray(voucherData.workflowStepResponses)) {
    const latestStep = voucherData.workflowStepResponses[voucherData.workflowStepResponses.length - 1];
    if (latestStep && (latestStep.action === "RESUBMITTED" || latestStep.status === "RESUBMITTED")) {
      return false;
    }
    if (latestStep && (latestStep.action === "ReworkApproved" || latestStep.status === "ReworkApproved")) {
      return false;
    }
  }

  // If any status is RESUBMITTED, voucher is no longer in rework
  if (l1Status && l1Status.toUpperCase().includes("RESUBMITTED")) return false;
  if (l2Status && l2Status.toUpperCase().includes("RESUBMITTED")) return false;
  if (l3Status && l3Status.toUpperCase().includes("RESUBMITTED")) return false;
  if (financeStatus && financeStatus.toUpperCase().includes("RESUBMITTED")) return false;

  // Check reworkStatus field
  const reworkStatus = voucherData?.reworkStatus;
  if (containsRework(reworkStatus) && !isReworkCompleteStatus(reworkStatus)) {
    return true;
  }

  // Check approval_status metadata (list API may only expose this)
  const approvalStatusAttr = voucherData?.dataModalAttributeSet?.find(
    (attr) => attr?.metadataTechnicalName === "approval_status"
  );
  const approvalStatus = approvalStatusAttr?.attributeValue || "";
  if (approvalStatus && containsRework(approvalStatus) && !isReworkCompleteStatus(approvalStatus)) {
    return true;
  }

  // REWORK_REQUESTED, REWORK_STARTED, REWORK_PENDING = in rework. Rework Approved = not in rework (already handled above).
  if (containsRework(l1Status)) return true;
  if (containsRework(l2Status)) return true;
  if (containsRework(l3Status)) return true;
  if (containsRework(financeStatus)) return true;

  return false;
};

/**
 * Helper: Check if a voucher/doc has action taken (approved/rejected/partially approved) at the given user level only.
 * Used so L2 buttons are not disabled when children only have L1 approved (normal flow).
 */
const hasActionTakenAtLevel = (doc, userLevel) => {
  if (!doc) return false;
  const level = (userLevel === "Finance" ? "L3" : userLevel) || "";
  
  let status = "";
  if (level === "L1") {
    status = doc?.newL1Status || doc?.l1Status || doc?.L1?.status || doc?.l1?.status || "";
  } else if (level === "L2") {
    status = doc?.newL2Status || doc?.l2Status || doc?.L2?.status || doc?.l2?.status || "";
  } else if (level === "L3") {
    status = doc?.newL3Status || doc?.l3Status || doc?.L3?.status || doc?.l3?.status || doc?.Finance?.status || doc?.financeStatus || "";
  } else {
    return false;
  }
  
  const statusLower = (status || "").toLowerCase();
  if (statusLower.includes("approved") || statusLower.includes("partially approved") || statusLower.includes("partiallyapproved")) return true;
  if (statusLower.includes("rejected") || statusLower === "stopped") return true;
  
  if (doc?.workflowStepResponses && Array.isArray(doc.workflowStepResponses)) {
    const stepForLevel = doc.workflowStepResponses.find((s) => (s?.userLabel || "").toLowerCase() === level.toLowerCase() || (s?.userLabel === "Finance" && level === "L3"));
    const stepStatus = (stepForLevel?.status || stepForLevel?.action || "").toLowerCase();
    if (stepStatus.includes("approved") || stepStatus.includes("partially approved") || stepStatus.includes("rejected") || stepStatus === "stopped") return true;
  }
  
  const approvalStatusAttr = doc?.dataModalAttributeSet?.find((attr) => attr?.metadataTechnicalName === "approval_status");
  const approvalStatus = (approvalStatusAttr?.attributeValue || "").toLowerCase();
  if (level === "L1" && (approvalStatus.includes("l1approved") || approvalStatus.includes("l1rejected"))) return true;
  if (level === "L2" && (approvalStatus.includes("l2approved") || approvalStatus.includes("l2rejected"))) return true;
  if (level === "L3" && (approvalStatus.includes("accountsapproved") || approvalStatus.includes("accountsrejected"))) return true;
  
  return false;
};

/**
 * Returns true if the row has any child in rework OR has any action taken at the current user's level.
 * Level-aware: for L2 we only disable when a child has L2 action (or rework), not when child has L1 approved.
 * @param {object} rowOriginal - Row data
 * @param {string} userActiveLevel - "L1" | "L2" | "L3" | "Finance"
 */
export const hasAnyChildInRework = (rowOriginal, userActiveLevel) => {
  if (!rowOriginal) return false;
  const level = (userActiveLevel === "Finance" ? "L3" : userActiveLevel) || "";

  const voucherHasReworkOrActionAtLevel = (voucher) => {
    if (!voucher) return false;
    
    if (level && hasActionTakenAtLevel(voucher, level)) return true;
    
    const reworkRequested = voucher?.reworkRequestedDocs?.length > 0;
    const reworkPending = voucher?.reworkPendingDocs?.length > 0;
    if (reworkRequested || reworkPending) return true;
    
    const allChildDocs = [
      ...(voucher?.pendingDocs || []),
      ...(voucher?.reworkRequestedDocs || []),
      ...(voucher?.reworkPendingDocs || []),
      ...(voucher?.approvedDocs || []),
      ...(voucher?.rejectedDocs || []),
    ];
    
    return allChildDocs.some((doc) => isVoucherInRework(doc) || (level && hasActionTakenAtLevel(doc, level)));
  };

  if (rowOriginal?.documents?.length) {
    if (rowOriginal.documents.some((v) => voucherHasReworkOrActionAtLevel(v))) return true;
  }

  return voucherHasReworkOrActionAtLevel(rowOriginal);
};

// Check if user can send back for rework
export const canSendBackForRework = (voucherData, userLevel) => {
  // Finance users are L3 users, so treat "Finance" as "L3"
  const normalizedLevel = userLevel === "Finance" ? "L3" : userLevel;
  if (!["L1", "L2", "L3"].includes(normalizedLevel)) return false;
  if (isVoucherInRework(voucherData)) return false;
  
  // Check if voucher is pending at user's level
  // Support both newL1Status and l1Status field names, and nested L1/L2/L3 objects
  // Also support lowercase l1/l2/l3 and Finance object
  const l1Status = voucherData?.newL1Status || voucherData?.l1Status || voucherData?.L1?.status || voucherData?.l1?.status || "";
  const l2Status = voucherData?.newL2Status || voucherData?.l2Status || voucherData?.L2?.status || voucherData?.l2?.status || "";
  let l3Status = voucherData?.newL3Status || voucherData?.l3Status || voucherData?.L3?.status || voucherData?.l3?.status || voucherData?.Finance?.status || "";
  
  // For L3/Finance: also check approval_status metadata field
  // If approval_status is "AccountsApprovalPending", voucher is pending at Finance level
  if (normalizedLevel === "L3" && !l3Status) {
    const approvalStatusAttr = voucherData?.dataModalAttributeSet?.find(
      (attr) => attr?.metadataTechnicalName === "approval_status"
    );
    const approvalStatus = approvalStatusAttr?.attributeValue || "";
    if (approvalStatus && approvalStatus.toUpperCase().includes("ACCOUNTSAPPROVALPENDING")) {
      l3Status = "Pending"; // Treat as pending at Finance level
    }
  }
  
  // If no status fields found, assume pending (for pending vouchers list)
  const hasStatusFields = l1Status || l2Status || l3Status;
  
  if (hasStatusFields) {
    // Check specific level status
    if (normalizedLevel === "L1" && l1Status !== "Pending" && l1Status !== "PENDING") return false;
    if (normalizedLevel === "L2" && l2Status !== "Pending" && l2Status !== "PENDING") return false;
    if (normalizedLevel === "L3" && l3Status !== "Pending" && l3Status !== "PENDING") return false;
  }
  // If no status fields, allow rework (assumes voucher is pending at user's level)
  
  return true;
};

// Check if user can edit voucher after rework (Store/L0 users only, when voucher is in rework)
export const canEditVoucherAfterRework = (voucherData, userLevel) => {
  // Only Store/L0 users can edit
  if (userLevel !== "Store" && userLevel !== "L0") return false;
  
  // Voucher must be in rework state
  if (!isVoucherInRework(voucherData)) return false;
  
  return true;
};